import type {
  BoxSpacing,
  TextContentData,
  TextElement,
} from '@/components/canvas/document/publicTypes';
import { type BaseElementConfig, createBase } from '../registry/factoryShared';
import type { TextBlockKind } from './utils/textContent';
import { createTextDocumentFromPlainText } from './model/textNormalize';

export function createTextContentData(config: {
  content?: string;
  blockKind?: TextBlockKind;
}): TextContentData {
  const blockKind = config.blockKind ?? 'paragraph';
  const content = config.content ?? '';

  return {
    content,
    contentVersion: 1,
    document: createTextDocumentFromPlainText(content, blockKind),
  };
}

export function createTextElement(
  config: BaseElementConfig & {
    data: TextContentData;
    padding?: BoxSpacing;
  },
): TextElement {
  const base = createBase('text', config);
  return {
    ...base,
    size: {
      ...base.size,
      padding: config.padding,
    },
    data: config.data,
  };
}
